import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconNewSectionBelow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3.25 4.75C3.25 4.33579 3.58579 4 4 4H20C20.4142 4 20.75 4.33579 20.75 4.75C20.75 5.16421 20.4142 5.5 20 5.5H4C3.58579 5.5 3.25 5.16421 3.25 4.75Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.25 15.25C6.25 14.8358 6.58579 14.5 7 14.5H11.25V10.25C11.25 9.83579 11.5858 9.5 12 9.5C12.4142 9.5 12.75 9.83579 12.75 10.25V14.5H17C17.4142 14.5 17.75 14.8358 17.75 15.25C17.75 15.6642 17.4142 16 17 16H12.75V20.25C12.75 20.6642 12.4142 21 12 21C11.5858 21 11.25 20.6642 11.25 20.25V16H7C6.58579 16 6.25 15.6642 6.25 15.25Z",
		fill: "currentColor"
	})]
});
export { SvgIconNewSectionBelow as ReactComponent };
